(() => {
  if (window.__shopDropGridAjax) return;
  window.__shopDropGridAjax = true;

  let abortController = null;

  const PREVIEW_PARAMS = ['_ab', '_fd', '_sc', 'preview_theme_id', 'key', 'pb', 'shape'];

  const getRoot = (el) => el?.closest?.('.shop-drop-grid');

  const normalizePath = (value) => {
    const url = new URL(value, window.location.origin);
    return url.pathname.replace(/\/$/, '') || '/';
  };

  const isAllCollectionPage = () => {
    const path = normalizePath(window.location.href);
    return /\/collections\/all$/.test(path);
  };

  const buildCollectionUrl = (value) => {
    const url = new URL(value, window.location.origin);
    url.hash = '';
    url.search = '';
    const current = new URL(window.location.href);
    PREVIEW_PARAMS.forEach((key) => {
      const param = current.searchParams.get(key);
      if (param) url.searchParams.set(key, param);
    });
    return url;
  };

  const setLoading = (root, isLoading) => {
    const results = root.querySelector('[data-ajax-results]');
    if (!results) return;
    results.classList.toggle('is-loading', isLoading);
    results.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const setActiveFilter = (root, activeFilter) => {
    root.querySelectorAll('.shop-drop-grid__filter[data-filter-url]').forEach((filter) => {
      const isActive = filter === activeFilter;
      filter.classList.toggle('shop-drop-grid__filter--active', isActive);
      if (isActive) {
        filter.setAttribute('aria-current', 'true');
      } else {
        filter.removeAttribute('aria-current');
      }
    });
  };

  const syncActiveFiltersFromPage = (root) => {
    const path = normalizePath(window.location.href);
    const filters = [...root.querySelectorAll('.shop-drop-grid__filter[data-filter-url]')];
    const matched = filters.find((filter) => normalizePath(filter.getAttribute('data-filter-url')) === path);
    const allFilter = root.querySelector('[data-filter-all]');
    setActiveFilter(root, matched || allFilter || filters[0]);
  };

  const replaceProducts = (root, html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('.shop-drop-grid') || doc.body;
    const currentProducts = root.querySelector('[data-ajax-products]');
    const nextProducts = incoming.querySelector('[data-ajax-products]');
    const currentCount = root.querySelector('[data-ajax-count]');
    const nextCount = incoming.querySelector('[data-ajax-count]');

    if (!currentProducts || !nextProducts) return false;
    currentProducts.replaceWith(nextProducts);
    if (currentCount && nextCount) currentCount.replaceWith(nextCount);
    return true;
  };

  const extractSectionHtml = async (response, sectionId) => {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const data = await response.json();
      return data[sectionId] || data[`shopify-section-${sectionId}`] || Object.values(data)[0] || '';
    }
    return response.text();
  };

  const fetchSectionHtml = async (collectionUrl, sectionId, signal) => {
    const sectionIdUrl = buildCollectionUrl(collectionUrl);
    sectionIdUrl.searchParams.set('section_id', sectionId);

    let response = await fetch(sectionIdUrl.toString(), { signal });
    if (response.ok) {
      const html = await extractSectionHtml(response, sectionId);
      if (html && html.includes('data-ajax-products')) return html;
    }

    const sectionsUrl = buildCollectionUrl(collectionUrl);
    sectionsUrl.searchParams.set('sections', sectionId);
    response = await fetch(sectionsUrl.toString(), {
      signal,
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Section request failed');

    const html = await extractSectionHtml(response, sectionId);
    if (!html || !html.includes('data-ajax-products')) throw new Error('Section HTML missing');
    return html;
  };

  const loadCollection = async (root, rawUrl, activeFilter) => {
    const sectionId = root.dataset.sectionId;
    if (!sectionId || !rawUrl) return false;

    const targetUrl = buildCollectionUrl(rawUrl);
    if (!normalizePath(targetUrl).includes('/collections/')) return false;

    if (abortController) abortController.abort();
    abortController = new AbortController();
    setLoading(root, true);
    setActiveFilter(root, activeFilter);

    try {
      const html = await fetchSectionHtml(targetUrl, sectionId, abortController.signal);
      const replaced = replaceProducts(root, html);
      if (!replaced) throw new Error('Products not found');
      setActiveFilter(root, activeFilter);
      return true;
    } catch (error) {
      if (error?.name === 'AbortError') return false;
      console.error('[collection-drop-grid]', error);
      return false;
    } finally {
      setLoading(root, false);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const filter = event.target.closest('[data-ajax-filter-link]');
      if (!filter) return;

      const root = getRoot(filter);
      if (!root || root.dataset.ajaxFilter !== 'true') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      if (!isAllCollectionPage()) return;

      const filterUrl = filter.getAttribute('data-filter-url') || filter.getAttribute('href');
      if (!filterUrl || filterUrl === '#') return;

      event.preventDefault();
      event.stopPropagation();

      if (filter.classList.contains('shop-drop-grid__filter--active')) return;

      loadCollection(root, filterUrl, filter);
    },
    true
  );

  const initActiveStates = () => {
    document.querySelectorAll('.shop-drop-grid').forEach((root) => {
      syncActiveFiltersFromPage(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initActiveStates, { once: true });
  } else {
    initActiveStates();
  }
})();
